import { render, staticRenderFns } from "./SaveCardPay.vue?vue&type=template&id=6ad60cd5&scoped=true"
import script from "./SaveCardPay.vue?vue&type=script&lang=js"
export * from "./SaveCardPay.vue?vue&type=script&lang=js"
import style0 from "./SaveCardPay.vue?vue&type=style&index=0&id=6ad60cd5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad60cd5",
  null
  
)

export default component.exports